import { createSelector } from 'reselect'

const mobileAppSelector = state => state.mobile_app

export function fromMobileSelector() {
  return createSelector(mobileAppSelector, mobileApp => mobileApp.from_app)
}
